import { APIClient } from "api/api_helper";
import { GetUserData, CurrentUser, formatDateSplit } from "common/service/CommonService";
import { DROPOUT_VOLUNTEER_API } from "api/url_helper";

const api = new APIClient();

export const dropoutVolunteerApiService = {
  // INSERT METHOD
  insertData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const formData = new FormData();
    
    // Map properties to match requested API payload
    const payload_data: Record<string, any> = {
      volunteerid: Number(payload.volunteerid),
      studyid: Number(payload.studyid),
      subjectno: payload.subjectno,
      dropouttype: Number(payload.dropouttype),
      remarks: payload.detailedremarks || null,
      studystage: payload.studystage,
      dropoutreason: Number(payload.dropoutreason),
      dropoutdate: formatDateSplit(payload.dropoutdate),
      effectivedate: formatDateSplit(payload.effectivedate),
      aereferenceno: payload.aereferenceno || null,
      createdby: user?.userid,
    };

    // Append form fields (compid, branid, database are appended automatically by api_helper for FormData)
    Object.entries(payload_data).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value as any);
      }
    });

    // Append files
    if (Array.isArray(payload.attachments)) {
      payload.attachments.forEach((file: File) => {
        formData.append("files", file);
      });
    }

    return api.create(DROPOUT_VOLUNTEER_API.DROPOUT_VOLUNTEER_API + "Insert", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // SELECT ALL METHOD
  getSelectAllData: (params: {
    searchText: string;
    currentPage: number;
    pageSize: number;
    studyid: number;
  }) => {
    const { searchText, currentPage, pageSize, studyid } = params;
    const payload = {
      searchtext: searchText,
      currentpage: currentPage,
      pagesize: pageSize,
      studyid: studyid,
    };
    return api.create(DROPOUT_VOLUNTEER_API.DROPOUT_VOLUNTEER_API + "SelectAll", payload);
  },

  // SELECT METHOD
  getSelectData: (volunteerdropoutid: number) => {
    const payload = {
      volunteerdropoutid: volunteerdropoutid,
    };
    return api.create(DROPOUT_VOLUNTEER_API.DROPOUT_VOLUNTEER_API + "Select", payload);
  },

  // UPDATE METHOD
  updateData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const formData = new FormData();
    
    // Map properties to match requested API payload
    const payload_data: Record<string, any> = {
      volunteerdropoutid: Number(payload.volunteerdropoutid),
      volunteerid: Number(payload.volunteerid),
      studyid: Number(payload.studyid),
      dropouttype: Number(payload.dropouttype),
      remarks: payload.detailedremarks || null,
      studystage: payload.studystage,
      dropoutreason: Number(payload.dropoutreason),
      dropoutdate: formatDateSplit(payload.dropoutdate),
      effectivedate: formatDateSplit(payload.effectivedate),
      aereferenceno: payload.aereferenceno || null,
      updatereason: payload.updatereason,
      updatedby: user?.userid,
    };

    // Append form fields
    Object.entries(payload_data).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value as any);
      }
    });

    // Append files
    if (Array.isArray(payload.attachments)) {
      payload.attachments.forEach((file: File) => {
        formData.append("files", file);
      });
    }

    // Handle deleted attachments array if any
    if (payload.deletedAttachmentIds && Array.isArray(payload.deletedAttachmentIds)) {
      formData.append("deletedAttachmentIds", JSON.stringify(payload.deletedAttachmentIds));
    }

    return api.create(DROPOUT_VOLUNTEER_API.DROPOUT_VOLUNTEER_API + "Update", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // VERIFY METHOD
  verifyData: (payload: any) => {
    return api.create(DROPOUT_VOLUNTEER_API.DROPOUT_VOLUNTEER_API + "Verify", payload);
  },

  // DELETE METHOD
  deleteData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const payload_data = {
      volunteerdropoutid: Number(payload.volunteerdropoutid),
      updatedby: user?.userid,
      updatereason: payload.updatereason,
    };
    return api.create(DROPOUT_VOLUNTEER_API.DROPOUT_VOLUNTEER_API + "Delete", payload_data);
  },
};
